import React, { useEffect, useState } from "react";

import "../../Css/OrderFilter.css";
import {
  Button,
  ConfigProvider,
  Divider,
  Form,
  Input,
  Select,
  message,
  Spin,
  Pagination,
  Card,
  Drawer,
} from "antd";
import "./AdminProductList.css";
import { getProfile } from "../../services/localStorageServices";
import { get, post } from "../../apiService";
import TitleComp from "./TitleComp";
import { FaEdit } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import AddProduct from "./Model/AddProduct";
import Pdf from "../Export/Pdf";
import Excel from "../Export/Excel";
import ImportProduct from "./Model/ImportProduct";
import PriceHistory from "./Model/PriceHistory";
import { IoMdRefreshCircle } from "react-icons/io";

// OrderFilter Component
const AdminProductList = () => {
  const { profile } = getProfile();
  const [spinLoading, setSpinLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });
  const [formDrawer] = Form.useForm();
  const [dataList, setDataList] = useState([]);
  const [priceTypeSelect, setPriceTypeSelect] = useState("FG");
  const [column, setColumn] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [priceColourTypeSelect, setPriceColourTypeSelect] = useState("White");

  const productList = [
    "VVS",
    "VS1",
    "VS2",
    "SI1",
    "SI2",
    "SI3",
    "I1",
    "I2",
    "I3",
    "PK",
    "HPK",
  ];

  const handleFetch = async (page, limit, priceTypeSelect, search) => {
    setSpinLoading(true);

    try {
      const action = "fetch";
      const priceType = "VVS,VS1,VS2,SI1,SI2,SI3,I1,I2,I3,PK,HPK"; // No need to redeclare limit and page
      // const type = priceTypeSelect;

      // Use the passed page and limit parameters
      const response = await get(
        `/product.php?action=${action}&limit=${limit}&page=${page}&priceType=${priceType}&type=${priceTypeSelect}&typeColor=${priceColourTypeSelect}${
          search ? "&search=" + search + "" : ""
        }`
      );

      if (response && response.total && response.list) {
        // Set pagination and data list
        setPagination((prev) => ({ ...prev, total: response.total }));
        setDataList(response.list);

        const tableData = response.list.map((value) => {
          const newData = value.price.reduce((acc, valueData) => {
            acc[valueData.priceType] = valueData.price;
            return acc;
          }, {});

          return { ...value, ...newData };
        });

        setTableData(tableData);

        // ================= Column =================
        // Ensure response.list[0] exists before proceeding
        if (response.list[0] && response.list[0].price) {
          const newColumn = response.list[0].price
            .filter((value) => value.type === priceTypeSelect)
            .map((value) => ({
              title: value.priceType + "(" + value.type + ")",
              dataIndex: value.priceType,
              key: value.priceType,
            }));

          const prevColumn = [
            { title: "Avg Weight", dataIndex: "avg_wt", key: "avg_wt" },
            { title: "Sieve", dataIndex: "sive_sizes", key: "sive_sizes" },
            { title: "Size(MM)", dataIndex: "diam_mm", key: "diam_mm" },
          ];

          setColumn([...prevColumn, ...newColumn]); // Set the column state
        }
      } else {
        throw new Error("Invalid response structure");
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setSpinLoading(false);
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      handleFetch(
        pagination.current,
        pagination.pageSize,
        priceTypeSelect,
        searchInput
      );
    }, 300);

    return () => clearTimeout(dbounce);
  }, [pagination.current, pagination.pageSize, priceColourTypeSelect, searchInput]); // Ensure `handleFetch` is included as a dependency

  const [visible, setVisible] = useState(false);
  const [currentRowData, setCurrentRowData] = useState(null);

  const showDrawer = (rowData) => {
    setCurrentRowData(rowData);
    setVisible(true);
    formDrawer.setFieldsValue(rowData); // Set form values with row data
  };

  const onClose = () => {
    setVisible(false);
  };

  const handleUpdateProduct = async (values) => {
    // API call logic goes here, you can use the `values` for the updated product4
    const formData = new FormData();
    formData.append("product_id", values.product_id);
    formData.append("avg_wt", values.avg_wt);
    formData.append("sive_sizes", values.sive_sizes);
    formData.append("diam_mm", values.diam_mm);
    formData.append("action", "updateProduct");
    try {
      const response = await post(`/product.php`, formData);
      if (response) {
        message.success("updated sucessfully");
      }
    } catch (error) {
      message.error("updated sucessfully");
    } finally {
    }
  };

  // ==================== Remove Product ==================

  const removeProduct = async (id) => {
    if (
      window.confirm(
        "Are you sure you want to remove? if you remove product all prices list also remove !"
      )
    ) {
      try {
        const formData = new FormData();

        formData.append("product_id", id);
        formData.append("is_active", 0);
        formData.append("action", "updateProduct");
        const response = await post(`/product.php`, formData);
        if (response) {
          message.success("Remove sucessfully");
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const colours = [
    {
      name: "Yellow",
      type: "HIJ",
    },
    {
      name: "Brown",
      type: "HIJ",
    },
    {
      name: "White",
      type: "FG",
    },
  ];

  return (
    <>
      <section className="orderFilter-sec-main">
        <div className="container">
          <TitleComp
            name="Product List"
            type="Product"
            totalData={pagination.total}
            setSearchInput={setSearchInput}
          />

          <div className="orderFilter-all-search-result-table">
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    headerColor: "rgb(255,255,255)",
                    headerBg: "var(--primeColor)",
                  },
                },
              }}
            >
              <div className="px-3 mb-sm-3">
                <div className="d-md-flex align-items-center justify-content-between pt-4">
                  <h5 className="orderFilter-result-limited-heading-tag mb-3 m-md-0 text-center text-md-left">
                    Result - All prices listed are in US dollars
                  </h5>
                  {profile.product_add === "1" && (
                    <div className="d-flex align-items-center justify-content-center justify-content-md-end">
                      <Select
                        value={priceTypeSelect}
                        options={[
                          { label: "FG", value: "FG" },
                          { label: "HIJ", value: "HIJ" },
                        ]}
                        onChange={(value) => {
                          setPriceTypeSelect(value);
                          setPriceColourTypeSelect(
                            colours.filter((val) => val.type === value)[0].name
                          );
                        }}
                      />
                      <Select
                        value={priceColourTypeSelect}
                        className="mx-3"
                        style={{width:100}}
                        options={colours
                          .filter((val) => val.type === priceTypeSelect)
                          .map((value) => ({
                            label: value.name,
                            value: value.name,
                          }))}
                        onChange={(value) => setPriceColourTypeSelect(value)}
                      />
                      <Button
                        className="bg-dark text-white"
                        icon={<IoMdRefreshCircle />}
                        onClick={() => handleFetch(1, 100, priceTypeSelect)}
                        loading={spinLoading}
                      >
                        Refresh
                      </Button>
                    </div>
                  )}
                </div>
                <Divider />
                <div className="d-flex align-items-center justify-content-between flex-column flex-md-row">
                  <div className="d-flex align-items-center orderFilter-show-entries text-muted">
                    {/* <label className="d-block">Show</label>&nbsp;
                    <label className="d-block">
                      <Select
                        value={pagination.pageSize}
                        onChange={(value) =>
                          setPagination((prev) => ({
                            ...prev,
                            pageSize: value,
                          }))
                        }
                      >
                        <Select.Option value="10" label="10">
                          10
                        </Select.Option>
                        {pagination.total > 10 ? (
                          <Select.Option value="25" label="25">
                            25
                          </Select.Option>
                        ) : null}
                        {pagination.total > 25 ? (
                          <Select.Option value="50" label="50">
                            50
                          </Select.Option>
                        ) : null}
                        {pagination.total > 50 ? (
                          <Select.Option value="100" label="100">
                            100
                          </Select.Option>
                        ) : null}
                      </Select>
                    </label> */}
                    <ImportProduct priceTypeSelect={priceTypeSelect} priceColourTypeSelect={priceColourTypeSelect} />
                    <AddProduct />
                  </div>
                  <div className="d-flex justify-content-sm-end mt-3 mb-3">
                    <Pdf
                      column={column}
                      data={tableData}
                      fileName={"sejal_diamonds_" + priceTypeSelect+"_"+priceColourTypeSelect}
                    />
                    &nbsp;&nbsp;
                    <Excel
                      column={column}
                      data={tableData}
                      fileName={"sejal_diamonds_" + priceTypeSelect+"_"+priceColourTypeSelect}
                    />
                  </div>{" "}
                </div>
              </div>
            </ConfigProvider>
            <Spin spinning={spinLoading}>
              <div className="table-container">
                <table>
                  <thead>
                    <tr className="orderFilter-tr-th px-2">
                      <th width="10%">Avg Weight</th>
                      <th width="10%">Sieve</th>
                      <th width="10%">Size (MM)</th>
                      {productList.map((value) => (
                        <th width="5%">{value}</th>
                      ))}

                      <th width="70%" style={{ textAlign: "right" }}>
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataList &&
                      dataList?.map((v, i) => (
                        <tr className="orderFilter-tr-td" key={i}>
                          <td>{v.avg_wt}</td>
                          <td>{v.sive_sizes}</td>
                          <td>{v.diam_mm}</td>

                          {productList.map((val) => (
                            <td>
                              <PriceHistory
                                data={
                                  v?.price?.filter(
                                    (va) =>
                                      va.type === priceTypeSelect &&
                                      va.priceType === val
                                  )[0]
                                }
                              />
                            </td>
                          ))}

                          <td style={{ textAlign: "right" }}>
                            <div className="buttonGroup d-flex justify-content-end">
                              {/* <PriceList
                                type={priceTypeSelect}
                                data={v.price.filter(
                                  (value) => value.type === priceTypeSelect
                                )}
                              /> */}

                              {profile.product_update === "1" && (
                                <Button
                                  onClick={() => showDrawer(v)}
                                  className="mx-2 bg-warning text-white"
                                >
                                  <FaEdit />
                                </Button>
                              )}
                              <Button
                                className="mx-2 bg-danger text-white"
                                onClick={() => removeProduct(v.product_id)}
                              >
                                <FaTrashAlt />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              {dataList &&
                dataList?.map((v, i) => (
                  <Card className="d-block d-md-none mb-3">
                    <div className="row">
                      <div className="col-6">Avg Weight </div>
                      <div className="col-2">-</div>
                      <div className="col-4">{v.avg_wt}</div>
                    </div>
                    <div className="row">
                      <div className="col-6">Sieve</div>
                      <div className="col-2">-</div>
                      <div className="col-4">{v.sive_sizes}</div>
                    </div>
                    <div className="row">
                      <div className="col-6">Size (MM) </div>
                      <div className="col-2">-</div>
                      <div className="col-4">{v.diam_mm}</div>
                    </div>

                    {productList.map((val, index) => (
                      <div className="row">
                        <div className="col-6">{val} </div>
                        <div className="col-2">-</div>{" "}
                        <div className="col-4">
                          <PriceHistory
                            data={
                              v?.price?.filter(
                                (va) =>
                                  va.type === priceTypeSelect &&
                                  va.priceType === val
                              )[0]
                            }
                          />
                        </div>
                      </div>
                    ))}

                    <div className="buttonGroup d-flex justify-content-center mt-4">
                      <Button
                        onClick={() => showDrawer(v)}
                        className="mx-2 bg-warning text-white"
                      >
                        <FaEdit />
                      </Button>
                      <Button
                        className="mx-2 bg-danger text-white"
                        onClick={() => removeProduct(v.product_id)}
                      >
                        <FaTrashAlt />
                      </Button>
                    </div>
                  </Card>
                ))}
            </Spin>

            {/* Drawer for updating product */}
            <Drawer
              title="Update Product"
              width={480}
              onClose={onClose}
              visible={visible}
              bodyStyle={{ paddingBottom: 80 }}
            >
              {currentRowData && (
                <Form
                  form={formDrawer}
                  layout="vertical"
                  onFinish={handleUpdateProduct}
                  initialValues={currentRowData} // Set initial values
                >
                  <Form.Item
                    className="d-none"
                    name="product_id"
                    label="product id"
                  >
                    <Input disabled />
                  </Form.Item>
                  <Form.Item name="sive_sizes" label="Sieve Size">
                    <Input />
                  </Form.Item>
                  <Form.Item name="diam_mm" label="Diam MM">
                    <Input />
                  </Form.Item>
                  <Form.Item name="avg_wt" label="Average Weight">
                    <Input />
                  </Form.Item>

                  {/* Add other fields similarly */}
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              )}
            </Drawer>
          </div>
        </div>
      </section>
    </>
  );
};

export default AdminProductList;
